// contentFeedReducer.js
import {
  GET_CONTENT_FEED_REQUEST,
  GET_CONTENT_FEED_SUCCESS,
  GET_CONTENT_FEED_FAILURE,
  REFRESH_CONTENT_FEED_REQUEST,
  REFRESH_CONTENT_FEED_SUCCESS,
  REFRESH_CONTENT_FEED_FAILURE,
  SEARCH_CONTENT_FEED_REQUEST,
  SEARCH_CONTENT_FEED_SUCCESS,
  SEARCH_CONTENT_FEED_FAILURE,
  CLEAR_CONTENT_FEED_SEARCH,
  CLEAR_CONTENT_FEED_REFRESH,
} from "../actions/contentFeedActions";

const initialState = {
  items: [],
  generatedAt: null,
  totalItems: 0,
  nextToken: null,
  searchResults: null,   // null = no active search; [] = search returned nothing
  searchKeyword: null,
  refreshStatus: null,   // "QUEUED" | "COMPLETED" | null
  loading: false,
  searching: false,
  error: null,
};

const contentFeedReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTENT_FEED_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_CONTENT_FEED_SUCCESS:
      return {
        ...state,
        items: action.payload.append
          ? [...(state.items || []), ...(action.payload.items || [])]
          : (action.payload.items || []),
        generatedAt: action.payload.generatedAt || null,
        totalItems: action.payload.totalItems || 0,
        nextToken: action.payload.nextToken || null,
        loading: false,
        error: null,
      };
    case GET_CONTENT_FEED_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case REFRESH_CONTENT_FEED_REQUEST:
      return { ...state, error: null };
    case REFRESH_CONTENT_FEED_SUCCESS:
      return {
        ...state,
        refreshStatus: action.payload?.status || "QUEUED",
        error: null,
      };
    case REFRESH_CONTENT_FEED_FAILURE:
      return { ...state, refreshStatus: null, error: action.payload };

    case SEARCH_CONTENT_FEED_REQUEST:
      return { ...state, searching: true, error: null };
    case SEARCH_CONTENT_FEED_SUCCESS:
      return {
        ...state,
        searchResults: action.payload?.items || [],
        searching: false,
        error: null,
      };
    case SEARCH_CONTENT_FEED_FAILURE:
      return { ...state, searching: false, error: action.payload };

    case CLEAR_CONTENT_FEED_SEARCH:
      return { ...state, searchResults: null, searchKeyword: null, searching: false };

    case CLEAR_CONTENT_FEED_REFRESH:
      return { ...state, refreshStatus: null };

    default:
      return state;
  }
};

export default contentFeedReducer;
